import React from 'react';
import { Authorized } from './authorized';
import { UnAuthorized } from './unauthorized';

export enum SecurityTypes {
    Authorized = 'authorized',
    UnAuthorized = 'unAuthorized',
}

interface Props {
    securityType: SecurityTypes;
    children?: React.ReactNode;
}

export const SecurityFactory = (props: Props) => {
    const { securityType, children } = props;

    return (
        <>
            {securityType === SecurityTypes.Authorized && (
                <Authorized>{children}</Authorized>
            )}
            {securityType === SecurityTypes.UnAuthorized && (
                <UnAuthorized>{children}</UnAuthorized>
            )}
        </>
    );
};
